import wolff_logo from '../../images/companies-logos/wolff.webp';
import lyor_logo from '../../images/lyor.webp';
import woodart_logo from '../../images/companies-logos/woodart.webp';
import grupo_rojemac_logo from '../../images/grupo-rojemac.webp';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';
import { Button } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import AppContext from '../../context/AppContext';

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const { logo } = useContext(AppContext);

  const handleLogout = () => {
    localStorage.removeItem('token');
    toast.info('Logout realizado com sucesso.');
    history.push('/login');
  };

  return (
    <div>
      {location.pathname.includes('search') && (
        <div id='logout-div'>
          <Button onClick={handleLogout} id='logout-button' variant='danger'>
            Sair
          </Button>
        </div>
      )}
      <div className='logo-container'>
        {logo !== 'rojemac' && logo !== 'lyor' && (
          <div className='logo-images-container'>
            <img src={grupo_rojemac_logo} id='logo' alt='logo-rojemac' />
          </div>
        )}
        {!!logo.length && (
          <div className='logo-images-container'>
            {logo === 'rojemac' ? (
              <>
                <img src={wolff_logo} id='wolf-logo-size' alt='logo-wolff' />
                <img src={woodart_logo} id='logo' alt='logo-woodart' />
              </>
            ) : (
              <>
                <img src={lyor_logo} id='logo' alt='logo-lyor' />
              </>
            )}
          </div>
        )}
      </div>
      <ToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default App;
